<template>
  <div class="product fs-16 pb-60">
    <div class="tt-3 fs-48 mt-30">
      {{sortName}}型号比较
      <div class="p-link pt-20" v-if="col">
        <span class="a-link" @click="showPop">查看所有型号 <i class="el-icon-arrow-right"></i></span>
      </div>
      <div class="p-link pt-20 mb-30">
        如需获得选购帮助，<router-link :to="{name: 'consult'}">可咨询我们的产品专家 <i class="el-icon-arrow-right"></i></router-link>
      </div>
    </div>
    <template v-if="col">
      <div class="grid-3 pb-40 sel-mol">
        <el-cascader
        v-model="selVal1"
        :options="options"
        :props="{emitPath: false}"
        @change="selChange('1')">
        </el-cascader>
        <el-cascader
        v-if="col > 1"
        v-model="selVal2"
        :options="options"
        :props="{emitPath: false}"
        @change="selChange('2')">
        </el-cascader>
        <el-cascader
        v-if="col > 2"
        v-model="selVal3"
        :options="options"
        :props="{emitPath: false}"
        @change="selChange('3')">
        </el-cascader>
      </div>
      <div class="grid-3 pb-60 pic-mol text-c">
        <div v-for="(o, i) in itemData" :key="i">
          <div class="a-pic-1">
            <img :src="o.frontCover" v-if="o.frontCover"/>
          </div>
          <p class="mt-30">RMB {{o.sellingPrice}} 起</p>
          <el-button type="primary" class="mt-20 btn-1" round @click="goDetail(o)">购买</el-button>
        </div>
      </div>
      <template v-for="(item, k, i) in parameterObj">
        <div class="fs-26 bor-b bold pb-30 mb-30" :key="i">
          {{k}}
        </div>
        <div class="grid-3 pb-60" :key="i + 'c'">
          <div v-for="o in col" :key="o">
            {{item[`i${o}`] || '--'}}
          </div>
        </div>
      </template>
    </template>
    <el-dialog :visible.sync="showDialog" width="90%" class="all-pd" top="3vh">
      <ul class="a-list" v-infinite-scroll="loadData" infinite-scroll-distance="50" infinite-scroll-disabled="disabled">
        <li v-for="o in dataList" :key="o.uuid">
          <div class="a-pic-1">
            <img :src="o.frontCover" v-if="o.frontCover"/>
          </div>
          <p class="mt-30 bold fs-16 t-overflow">{{o.productName}}</p>
          <p class="mt-10">RMB {{o.sellingPrice}} 起</p>
          <el-button type="primary" class="mt-20 btn-1" round @click="goDetail(o)">购买</el-button>
          <div class="msg-list mt-20">
            <div class="a-msg" v-for="(m, i) in o.pList" :key="i">
              <p class="a-val">{{m.parameterValue || '--'}}</p>
              <p>{{m.parameterName}}</p>
            </div>
          </div>
        </li>
      </ul>
      <div v-loading="true" v-if="loading" class="a-spinner fs-26" element-loading-spinner="el-icon-loading"></div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'productCompare',
  data () {
    let query = this.$route.query
    return {
      sortName: query.sortName || '',
      sortUuid: query.id || '',
      selVal1: '',
      selVal2: '',
      selVal3: '',
      itemData: {},
      parameterObj: {},
      col: 0,
      options: [],
      dataObj: {},
      showDialog: false,
      currentPage: 1,
      pageSize: 9,
      loading: false,
      noMore: false,
      dataList: []
    }
  },
  mounted () {
    this.getData()
  },
  computed: {
    disabled () {
      return this.loading || this.noMore
    }
  },
  methods: {
    getData () {
      this.API.product.getProductInfoForCompare({
        sortUuid: this.sortUuid
      }).then((res) => {
        let data = res.data || []
        let options = []
        let dataObj = {}
        let i = 0
        data.map(item => {
          let productList = item.productList || []
          let children = []
          productList.map(o => {
            children.push({
              label: o.productName,
              value: o.uuid
            })
            o.parameterList = o.parameterList || []
            o.parameterList = o.parameterList.sort((a, b) => { return a.parameterType - b.parameterType })
            dataObj[`id${o.uuid}`] = o
            if (i < 3) {
              this[`selVal${i + 1}`] = o.uuid
              this.itemData[`i${i + 1}`] = o
            }
            i++
          })
          if (children.length) {
            options.push({
              label: item.brandName,
              value: item.brandUuid,
              children
            })
          }
        })
        this.options = options
        this.dataObj = dataObj
        this.col = i > 3 ? 3 : i
        this.getParams()
      })
    },
    getParams () {
      let obj = {}
      for (let k in this.itemData) {
        let parameterList = this.itemData[k].parameterList
        parameterList.map(o => {
          if (!obj[o.parameterName]) {
            obj[o.parameterName] = {}
          }
          obj[o.parameterName][k] = o.parameterValue
        })
      }
      this.parameterObj = obj
    },
    selChange (i) {
      let val = this[`selVal${i}`]
      let item = this.dataObj[`id${val}`]
      this.itemData[`i${i}`] = item
      this.getParams()
    },
    showPop () {
      this.showDialog = !this.showDialog
    },
    loadData () {
      this.loading = true
      this.API.product.getPageProductInfoBySort({
        sortUuid: this.sortUuid,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }).then((res) => {
        let data = res.data || {}
        data = data.list || []
        data.map(o => {
          o.parameterList = o.parameterList || []
          let _parameterList = []
          o.parameterList.map((p, i) => {
            if (p.parameterType === 1) {
              if (i < 6) {
                _parameterList.push(p)
              }
            }
          })
          o.pList = _parameterList
          return o
        })
        this.dataList = this.dataList.concat(data)
        this.noMore = !data.length || data.length < this.pageSize
        this.currentPage += 1
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    goDetail (o) {
      this.$router.push({
        name: 'productDetail',
        query: {
          id: o.uuid
        }
      })
    }
  }
}
</script>
